/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SubscribeRequestBillingCadence } from './subscribeRequestBillingCadence';
import type { SubscribeRequestPlanSlug } from './subscribeRequestPlanSlug';

export interface SubscribeRequest {
  plan_slug: SubscribeRequestPlanSlug;
  billing_cadence: SubscribeRequestBillingCadence;
  /**
     * @minimum 1
     * @maximum 10
     */
  seat_count: number;
  payment_method_id?: string | null;
  discount_code?: string | null;
  company_name?: string | null;
  billing_email?: string | null;
  address_country?: string | null;
  address_line1?: string | null;
  address_city?: string | null;
  address_state?: string | null;
  address_postal_code?: string | null;
  comet_token?: string | null;
}
